var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.openForm)?_c('BaseButton',{staticClass:"w-91",attrs:{"theme":"red"},on:{"click":function($event){_vm.openForm = true}}},[_vm._v(" "+_vm._s(_vm.$t('createLabel'))+" ")]):_c('TicketSystemAddForm')}
var staticRenderFns = []

export { render, staticRenderFns }